import { t, tf } from "../i18n";
const STORAGE_KEY = 'compare_products';
const MAX_ITEMS = 4;
let compareLimitPopupTimer = null;

const getStoredProducts = () => {
    try {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
        return Array.isArray(data) ? data : [];
    } catch (error) {
        return [];
    }
};

const setStoredProducts = (products) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
};

const isSameProduct = (a, b) => String(a.id) === String(b.id);

const addProduct = (product) => {
    const products = getStoredProducts();

    const exists = products.some((item) => isSameProduct(item, product));
    if (exists) {
        return products;
    }

    if (products.length >= MAX_ITEMS) {
        return products;
    }

    const updatedProducts = [...products, product];
    setStoredProducts(updatedProducts);

    return updatedProducts;
};

const removeProduct = (productId) => {
    const products = getStoredProducts();
    const updatedProducts = products.filter(
        (item) => String(item.id) !== String(productId)
    );

    setStoredProducts(updatedProducts);

    return updatedProducts;
};

const clearProducts = () => {
    localStorage.removeItem(STORAGE_KEY);
};

const showCompareLimitPopup = () => {
    const popup = document.querySelector('.popup-compare');
    if (!popup) return;

    popup.classList.add('popup-compare--visible');

    if (compareLimitPopupTimer) {
        window.clearTimeout(compareLimitPopupTimer);
    }

    compareLimitPopupTimer = window.setTimeout(() => {
        popup.classList.remove('popup-compare--visible');
        compareLimitPopupTimer = null;
    }, 3000);
};

const syncCheckboxes = () => {
    const products = getStoredProducts();
    const selectedIds = products.map((item) => String(item.id));

    const checkboxes = document.querySelectorAll('[data-compare-checkbox]');

    checkboxes.forEach((checkbox) => {
        const productId = checkbox.dataset.productId;
        checkbox.checked = selectedIds.includes(String(productId));
    });
};

const renderPopupItems = (products, itemsContainer) => {
    if (!itemsContainer) return;

    if (!products.length) {
        itemsContainer.innerHTML = '';
        return;
    }

    itemsContainer.innerHTML = products
        .map(
            (product) => `
                <div class="compare-popup__item" data-compare-item>
                  
                    <input checked
                        type="checkbox" 
                        class="compare-popup__remove checkbox"
                        data-compare-remove="${product.id}"
                        aria-label="${tf("compareRemoveAria", "Usuń %{title} z porównania", { title: product.title })}" /
                    >

                      <span class="compare-popup__item-title">${product.title}</span>
                    
                </div>
            `
        )
        .join('');
};

const updatePopupState = () => {
    const popup = document.querySelector('[data-compare-popup]');
    const countElement = document.querySelector('[data-compare-count]');
    const itemsContainer = document.querySelector('[data-compare-items]');
    const goButton = document.querySelector('[data-compare-go]');

    if (!popup) return;

    const products = getStoredProducts();
    const count = products.length;

    popup.hidden = count === 0;

    // hide order offer button when compare popup has items
    const orderOffer = document.querySelector('.order-offer');
    if (orderOffer) {
        orderOffer.classList.toggle('order-offer--hidden', count > 0);
    }

    if (countElement) {
        countElement.textContent = tf("comparePopupCount", "%{count} z %{max}", {
            count,
            max: MAX_ITEMS,
        });
    }

    if (goButton) {
        goButton.classList.toggle('is-disabled', count < 2);
        goButton.setAttribute('aria-disabled', count < 2 ? 'true' : 'false');
    }

    renderPopupItems(products, itemsContainer);
    syncCheckboxes();
};

const handleCheckboxChange = (event) => {
    const checkbox = event.target.closest('[data-compare-checkbox]');
    if (!checkbox) return;

    const product = {
        id: checkbox.dataset.productId,
        title: checkbox.dataset.productTitle,
        url: checkbox.dataset.productUrl || '',
    };

    if (checkbox.checked) {
        const before = getStoredProducts();
        const after = addProduct(product);

        // Jeśli limit został osiągnięty i produkt nie został dodany,
        // cofamy checkbox.
        if (before.length === after.length && !before.some((item) => isSameProduct(item, product))) {
            checkbox.checked = false;
            showCompareLimitPopup();
        }
    } else {
        removeProduct(product.id);
    }

    updatePopupState();
};

const handlePopupClick = (event) => {
    const removeButton = event.target.closest('[data-compare-remove]');
    const goButton = event.target.closest('[data-compare-go]');
    const addCompareBtn = event.target.closest('[data-add-compare]');

    if (removeButton) {
        const productId = removeButton.dataset.compareRemove;
        removeProduct(productId);
        updatePopupState();
        return;
    }

    if (addCompareBtn) {
        const product = {
            id: addCompareBtn.dataset.productId,
            title: addCompareBtn.dataset.productTitle,
            url: addCompareBtn.dataset.productUrl || '',
        };

        const before = getStoredProducts();
        const after = addProduct(product);

        if (before.length === after.length && !before.some((item) => isSameProduct(item, product))) {
            showCompareLimitPopup();
        }

        updatePopupState();
        return;
    }

    if (goButton) {
        const products = getStoredProducts();

        if (products.length < 2) {
            event.preventDefault();
            alert(t("compareNeedTwoProductsAlert", "Wybierz przynajmniej 2 produkty do porównania."));
        }
    }
};

export const comparePopup = () => {
    const popup = document.querySelector('[data-compare-popup]');
    const checkboxes = document.querySelectorAll('[data-compare-checkbox]');

    if (!popup && !checkboxes.length) return;

    updatePopupState();

    document.addEventListener('change', handleCheckboxChange);
    document.addEventListener('click', handlePopupClick);

    // Synchronizacja między kartami/przeglądarką
    window.addEventListener('storage', (event) => {
        if (event.key === STORAGE_KEY) {
            updatePopupState();
        }
    });
};